import { DashboardPage } from '@/client/components/dashboard/DashboardPage';
import { UserDashboard } from '@/client/components/dashboard/UserDashboard';
import { trpc } from '@/client/utils/trpc';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/')({ component: HomePage });

function HomePage() {
  const { data: me, isLoading } = trpc.user.me.useQuery();
  // Wait for the role so admins don't see the employee dashboard flash first.
  if (isLoading) return null;
  if (me?.role !== 'ADMIN') {
    return <UserDashboard />;
  }
  return <DashboardPage />;
}
